define([
    'text!WebCommon/component/sub-nav.html',
    'jquery',
    'WebCommon/utils'

], function(
    tpl,
    $,
    Utils
){
    return {
        template: tpl,
        props: {
            menu: {
                type: Array
            },
            menuParent: {
                type: Object
            },
            offsetLeft: {
                type: Number,
                default: 0
            }
        },
        computed: {
            innerStyle: function(){
                return {
                    marginLeft: this.offsetLeft+ 'px'
                };
            }
        },
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/component/sub-nav.js
// module id = 61
// module chunks = 0 1 2 3 4 5 6